import React from 'react';//, { Component }

const Modal = ({ className, children, isOpen }) => {
    if (isOpen) {
        return (
            <div className={className} style={{ display: 'block' }}>
                {children}
            </div>)
    }
    else return (<div />)
}

const ModalFade = ({ className, children, isOpen }) => {
    if (isOpen) {
        return (
            <div>
                <Modal className={className} children={children} isOpen={isOpen}/>
                <div className="modal-backdrop fade in" />

            </div>)
    }
    else return (<div />)
}



export { Modal, ModalFade };